<template>
    <div id="apps">
        <Banner></Banner>
    </div>
</template>

<script>
import Banner from './components/Banner.vue';

export default {
    name: 'App',
    components: {
        Banner,
    },
    mounted: function() {
        if (this._isMobile()) {
            window.location.href='http://www.artgogo.com/online-exhibition/tobewillbe/index.html';
        } else{
            //window.location.href='http://www.artgogo.com/online-exhibition/tobewillbe/indexd.html';
        }
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
    },
};
</script>

<style lang="scss">
#apps {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    text-align: center;
    height: 100%;
    overflow: hidden;
    position: relative;
}
</style>
